<template lang="pug">
footer.footer
  section.footerBackground
  section.footerContainer
    //- Social.footerSocial
    div © 2026 Ian Hurdle | 
    router-link.footer-privacyLink(:to='{ name: "PrivacyPage" }') Privacy Policy
</template>

<script>
  export default {
    components: {
      Social: () => import('@/components/Social'),
    },
  };
</script>

<style lang="scss">
  // @import "@/styles/settings.scss";

  .footer {
    display: contents;
    font-size: 18px;
    

    &Background {
      
      height: 150px;
      background: #1F1E1E;
      color: white;
      
      @include tablet {
        height: 140px;

      }

      @include phone {
        height: 84px;
      }
    }
    &Container {
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      
      &:before{
        content: '';
        position: absolute;
        height:1px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: radial-gradient(50% 50% at 50% 50%, rgba(255, 250, 243, 0) 0%, #FFFAF3 50%, rgba(255, 250, 243, 0) 100%);
      }

      @include tablet {
        /* flex-direction: column; */
        justify-content: center;
        font-size: 16px;

        /* @include gap(40px, col); */
      }
    }
    &-privacyLink {
      width: auto;
      text-align: right;
      margin-left: 4px;
      @include tablet {
        text-align: center;
      }
     
    }
    &Social {
      display: flex;
      align-items: center;
      @include gap(40px, row);
    }

    a {
      transition: 0.2s color;
    }
    a:hover {
      color: #cccccc;
    }

    a:active {
      color: #939393;
    }
  }

  /* .singlePage + .footer {
    @include tablet {
      .footerBackground {
        height: 320px;
      }
      .footer-privacyLink {
        margin-bottom: 60px;
      }
    }
    @include phone {
      .footer-privacyLink{
        margin: 0 !important;
      }
    }
  } */
</style>
